import { render, staticRenderFns } from "./OrderStatus.vue?vue&type=template&id=6266263d&scoped=true&"
import script from "./OrderStatus.vue?vue&type=script&lang=js&"
export * from "./OrderStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatus.vue?vue&type=style&index=0&id=6266263d&prod&lang=css&"
import style1 from "./OrderStatus.vue?vue&type=style&index=1&id=6266263d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6266263d",
  null
  
)

export default component.exports